"use strict";
/*
 * HSSelect
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var constants_1 = require("../../constants");
var HSSelect = /** @class */ (function (_super) {
    __extends(HSSelect, _super);
    function HSSelect(el, options) {
        var _a;
        var _this = _super.call(this, el, options) || this;
        _this.optionId = 0;
        var data = el.getAttribute('data-hs-select');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        var defaultToggleSeparators = {
            items: ', ',
            betweenItemsAndCounter: 'and',
        };
        _this.value =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.value) || _this.el.value || null;
        _this.placeholder = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.placeholder) || 'Select...';
        _this.hasSearch = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.hasSearch) || false;
        _this.preventSearchFocus = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.preventSearchFocus) || false;
        _this.mode = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.mode) || 'default';
        _this.viewport =
            typeof (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.viewport) !== 'undefined'
                ? document.querySelector(concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.viewport)
                : null;
        _this.isOpened = Boolean(concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isOpened) || false;
        _this.isMultiple = _this.el.hasAttribute('multiple') || false;
        _this.isDisabled = _this.el.hasAttribute('disabled') || false;
        _this.selectedItems = [];
        _this.apiUrl = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiUrl) || null;
        _this.apiQuery = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiQuery) || null;
        _this.apiOptions = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiOptions) || null;
        _this.apiSearchQueryKey = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiSearchQueryKey) || null;
        _this.apiDataPart = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiDataPart) || null;
        _this.apiFieldsMap = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiFieldsMap) || null;
        _this.apiIconTag = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiIconTag) || null;
        _this.wrapperClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.wrapperClasses) || null;
        _this.toggleTag = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.toggleTag) || null;
        _this.toggleClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.toggleClasses) || null;
        _this.toggleSeparators = defaultToggleSeparators;
        _this.toggleCountText = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.toggleCountText) || null;
        _this.toggleCountTextMinItems = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.toggleCountTextMinItems) || 1;
        _this.toggleCountTextMode =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.toggleCountTextMode) || 'countAfterLimit';
        _this.tagsItemTemplate = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.tagsItemTemplate) || null;
        _this.tagsItemClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.tagsItemClasses) || null;
        _this.tagsInputId = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.tagsInputId) || null;
        _this.tagsInputClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.tagsInputClasses) || null;
        _this.dropdownTag = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.dropdownTag) || null;
        _this.dropdownClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.dropdownClasses) || null;
        _this.dropdownDirectionClasses =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.dropdownDirectionClasses) || null;
        _this.dropdownSpace = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.dropdownSpace) || 10;
        _this.dropdownPlacement = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.dropdownPlacement) || null;
        _this.dropdownScope = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.dropdownScope) || 'parent';
        _this.searchTemplate = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchTemplate) || null;
        _this.searchWrapperTemplate = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchWrapperTemplate) || null;
        _this.searchWrapperClasses =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchWrapperClasses) || 'bg-white p-2 sticky top-0';
        _this.searchId = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchId) || null;
        _this.searchLimit = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchLimit) || Infinity;
        _this.isSearchDirectMatch =
            typeof (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isSearchDirectMatch) !== 'undefined'
                ? concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isSearchDirectMatch
                : true;
        _this.searchClasses =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchClasses) ||
                'block w-[calc(100%-2rem)] text-sm border-gray-200 rounded-md focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 py-2 px-3 my-2 mx-4';
        _this.searchPlaceholder = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchPlaceholder) || 'Search...';
        _this.searchNoResultTemplate =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchNoResultTemplate) || '<span></span>';
        _this.searchNoResultText =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchNoResultText) || 'No results found';
        _this.searchNoResultClasses =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.searchNoResultClasses) ||
                'px-4 text-sm text-gray-800 dark:text-neutral-200';
        _this.optionTemplate = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.optionTemplate) || null;
        _this.optionTag = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.optionTag) || null;
        _this.optionClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.optionClasses) || null;
        _this.extraMarkup = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.extraMarkup) || null;
        _this.descriptionClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.descriptionClasses) || null;
        _this.iconClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.iconClasses) || null;
        _this.isAddTagOnEnter = (_a = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isAddTagOnEnter) !== null && _a !== void 0 ? _a : true;
        _this.animationInProcess = false;
        _this.selectOptions = [];
        _this.remoteOptions = [];
        _this.tagsInputHelper = null;
        _this.init();
        return _this;
    }
    HSSelect.prototype.setValue = function (val) {
        this.value = val;
        this.clearSelections();
        if (Array.isArray(val)) {
            this.toggleTextWrapper.innerHTML = this.value.length
                ? this.stringFromValue()
                : this.placeholder;
            this.unselectMultipleItems();
            this.selectMultipleItems();
        }
        else {
            this.setToggleTitle();
            if (this.toggle.querySelector('[data-icon]'))
                this.setToggleIcon();
            if (this.toggle.querySelector('[data-title]'))
                this.setToggleTitle();
            this.selectSingleItem();
        }
    };
    HSSelect.prototype.init = function () {
        this.createCollection(window.$hsSelectCollection, this);
        this.build();
    };
    HSSelect.prototype.build = function () {
        var _this = this;
        this.el.style.display = 'none';
        if (this.el.children) {
            Array.from(this.el.children)
                .filter(function (el) { return el.value && el.value !== ''; })
                .forEach(function (el) {
                var data = el.getAttribute('data-hs-select-option');
                _this.selectOptions = __spreadArray(__spreadArray([], _this.selectOptions, true), [
                    {
                        title: el.textContent,
                        val: el.value,
                        disabled: el.disabled,
                        options: data !== 'undefined' ? JSON.parse(data) : null,
                    },
                ], false);
            });
        }
        if (this.isMultiple) {
            var selectedOptions = Array.from(this.el.children).filter(function (el) { return el.selected; });
            if (selectedOptions) {
                var values_1 = [];
                selectedOptions.forEach(function (el) {
                    values_1.push(el.value);
                });
                this.value = values_1;
            }
        }
        this.buildWrapper();
        if (this.mode === 'tags')
            this.buildTags();
        else
            this.buildToggle();
        this.buildDropdown();
        if (this.extraMarkup)
            this.buildExtraMarkup();
    };
    HSSelect.prototype.buildWrapper = function () {
        var _this = this;
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('hs-select', 'relative');
        if (this.mode === 'tags') {
            this.wrapper.addEventListener('click', function (evt) {
                if (!evt.target.closest('[data-hs-select-dropdown]') &&
                    !evt.target.closest('[data-tag-value]')) {
                    _this.tagsInput.focus();
                }
            });
        }
        if (this.wrapperClasses)
            (0, utils_1.classToClassList)(this.wrapperClasses, this.wrapper);
        this.el.before(this.wrapper);
        this.wrapper.append(this.el);
    };
    HSSelect.prototype.buildExtraMarkup = function () {
        var _this = this;
        var appendMarkup = function (markup) {
            var el = (0, utils_1.htmlToElement)(markup);
            _this.wrapper.append(el);
            return el;
        };
        var clickHandle = function (el) {
            if (!el.classList.contains('--prevent-click'))
                el.addEventListener('click', function (evt) {
                    evt.stopPropagation();
                    _this.toggleFn();
                });
        };
        if (Array.isArray(this.extraMarkup)) {
            this.extraMarkup.forEach(function (el) {
                var newEl = appendMarkup(el);
                clickHandle(newEl);
            });
        }
        else {
            var newEl = appendMarkup(this.extraMarkup);
            clickHandle(newEl);
        }
    };
    HSSelect.prototype.buildToggle = function () {
        var _this = this;
        var _a, _b;
        var icon, title;
        this.toggleTextWrapper = document.createElement('span');
        this.toggleTextWrapper.classList.add('truncate');
        this.toggle = (0, utils_1.htmlToElement)(this.toggleTag || '<div></div>');
        icon = this.toggle.querySelector('[data-icon]');
        title = this.toggle.querySelector('[data-title]');
        if (!this.isMultiple && icon)
            this.setToggleIcon();
        if (!this.isMultiple && title)
            this.setToggleTitle();
        if (this.isMultiple) {
            this.toggleTextWrapper.innerHTML = this.value.length
                ? this.stringFromValue()
                : this.placeholder;
        }
        else {
            this.toggleTextWrapper.innerHTML =
                ((_a = this.getItemByValue(this.value)) === null || _a === void 0 ? void 0 : _a.title) || this.placeholder;
        }
        if (!title)
            this.toggle.append(this.toggleTextWrapper);
        if (this.toggleClasses)
            (0, utils_1.classToClassList)(this.toggleClasses, this.toggle);
        if (this.isDisabled)
            this.toggle.classList.add('disabled');
        if (this.wrapper)
            this.wrapper.append(this.toggle);
        if ((_b = this.toggle) === null || _b === void 0 ? void 0 : _b.ariaExpanded) {
            if (this.isOpened)
                this.toggle.ariaExpanded = 'true';
            else
                this.toggle.ariaExpanded = 'false';
        }
        this.toggle.addEventListener('click', function () {
            if (_this.isDisabled)
                return false;
            _this.toggleFn();
        });
    };
    HSSelect.prototype.setToggleIcon = function () {
        var _a;
        var item = this.getItemByValue(this.value);
        var icon = this.toggle.querySelector('[data-icon]');
        icon.innerHTML = '';
        if (icon) {
            var img = (0, utils_1.htmlToElement)(this.apiUrl && this.apiIconTag
                ? this.apiIconTag || ''
                : ((_a = item === null || item === void 0 ? void 0 : item.options) === null || _a === void 0 ? void 0 : _a.icon) || '');
            if (this.value && this.apiUrl && this.apiIconTag && item[this.apiFieldsMap.icon])
                img.src = item[this.apiFieldsMap.icon] || '';
            icon.append(img);
            if (!img || !(img === null || img === void 0 ? void 0 : img.src))
                icon.classList.add('hidden');
            else
                icon.classList.remove('hidden');
        }
    };
    HSSelect.prototype.setToggleTitle = function () {
        var _a;
        var title = this.toggle.querySelector('[data-title]');
        title.classList.add('truncate');
        title.innerHTML = '';
        if (title) {
            var titleText = ((_a = this.getItemByValue(this.value)) === null || _a === void 0 ? void 0 : _a.title) || this.placeholder;
            title.innerHTML = titleText;
            this.toggle.append(title);
        }
    };
    HSSelect.prototype.buildTags = function () {
        if (this.isDisabled)
            this.wrapper.classList.add('disabled');
        this.buildTagsInput();
        this.setTagsItems();
    };
    HSSelect.prototype.reassignTagsInputPlaceholder = function (placeholder) {
        this.tagsInput.placeholder = placeholder;
        this.tagsInputHelper.innerHTML = placeholder;
        this.calculateInputWidth();
    };
    HSSelect.prototype.buildTagsItem = function (val) {
        var _this = this;
        var _a, _b, _c, _d;
        var item = this.getItemByValue(val);
        var template, title, remove, icon;
        var newItem = document.createElement('div');
        newItem.setAttribute('data-tag-value', val);
        if (this.tagsItemClasses)
            (0, utils_1.classToClassList)(this.tagsItemClasses, newItem);
        if (this.tagsItemTemplate) {
            template = (0, utils_1.htmlToElement)(this.tagsItemTemplate);
            newItem.append(template);
        }
        // Icon
        if (((_a = item === null || item === void 0 ? void 0 : item.options) === null || _a === void 0 ? void 0 : _a.icon) || this.apiIconTag) {
            var img = (0, utils_1.htmlToElement)(this.apiUrl && this.apiIconTag
                ? this.apiIconTag
                : (_b = item === null || item === void 0 ? void 0 : item.options) === null || _b === void 0 ? void 0 : _b.icon);
            if (this.apiUrl && this.apiIconTag && item[this.apiFieldsMap.icon])
                img.src = item[this.apiFieldsMap.icon] || '';
            icon = template
                ? template.querySelector('[data-icon]')
                : document.createElement('span');
            icon.append(img);
            if (!template)
                newItem.append(icon);
        }
        if (template &&
            template.querySelector('[data-icon]') &&
            !((_c = item === null || item === void 0 ? void 0 : item.options) === null || _c === void 0 ? void 0 : _c.icon) &&
            !this.apiUrl &&
            !this.apiIconTag &&
            !item[(_d = this.apiFieldsMap) === null || _d === void 0 ? void 0 : _d.icon]) {
            template.querySelector('[data-icon]').classList.add('hidden');
        }
        // Title
        title = template
            ? template.querySelector('[data-title]')
            : document.createElement('span');
        title.textContent = item.title || '';
        if (!template)
            newItem.append(title);
        // Remove
        if (template) {
            remove = template.querySelector('[data-remove]');
        }
        else {
            remove = document.createElement('span');
            remove.textContent = 'X';
            newItem.append(remove);
        }
        remove.addEventListener('click', function () {
            _this.value = _this.value.filter(function (el) { return el !== val; });
            _this.selectedItems = _this.selectedItems.filter(function (el) { return el !== val; });
            if (!_this.value.length)
                _this.reassignTagsInputPlaceholder(_this.placeholder);
            _this.unselectMultipleItems();
            _this.selectMultipleItems();
            newItem.remove();
            _this.fireEvent('change', _this.value);
            (0, utils_1.dispatch)('change.hs.select', _this.el, _this.value);
        });
        this.wrapper.append(newItem);
    };
    HSSelect.prototype.getItemByValue = function (val) {
        var _this = this;
        var value = this.apiUrl
            ? this.remoteOptions.find(function (el) { return el[_this.apiFieldsMap.title] === val; })
            : this.selectOptions.find(function (el) { return el.val === val; });
        return value;
    };
    HSSelect.prototype.setTagsItems = function () {
        var _this = this;
        if (this.value) {
            this.value.forEach(function (val) {
                if (!_this.selectedItems.includes(val))
                    _this.buildTagsItem(val);
                _this.selectedItems = !_this.selectedItems.includes(val)
                    ? __spreadArray(__spreadArray([], _this.selectedItems, true), [val], false) : _this.selectedItems;
            });
        }
    };
    HSSelect.prototype.buildTagsInput = function () {
        var _this = this;
        this.tagsInput = document.createElement('input');
        if (this.tagsInputId)
            this.tagsInput.id = this.tagsInputId;
        if (this.tagsInputClasses)
            (0, utils_1.classToClassList)(this.tagsInputClasses, this.tagsInput);
        this.tagsInput.addEventListener('focus', function () {
            if (!_this.isOpened)
                _this.open();
        });
        this.tagsInput.addEventListener('input', function () { return _this.calculateInputWidth(); });
        this.tagsInput.addEventListener('input', (0, utils_1.debounce)(function (evt) {
            return _this.searchOptions(evt.target.value);
        }));
        this.tagsInput.addEventListener('keydown', function (evt) {
            if (evt.key === 'Enter' && _this.isAddTagOnEnter) {
                var val_1 = evt.target.value;
                if (_this.selectOptions.find(function (el) { return el.val === val_1; }))
                    return false;
                _this.addSelectOption(val_1, val_1);
                _this.buildOption(val_1, val_1);
                _this.dropdown.querySelector("[data-value=\"".concat(val_1, "\"]")).click();
                _this.resetTagsInputField();
                // this.close();
            }
        });
        this.wrapper.append(this.tagsInput);
        setTimeout(function () {
            _this.adjustInputWidth();
            _this.reassignTagsInputPlaceholder(_this.value.length ? '' : _this.placeholder);
        });
    };
    HSSelect.prototype.buildDropdown = function () {
        var _this = this;
        this.dropdown = (0, utils_1.htmlToElement)(this.dropdownTag || '<div></div>');
        this.dropdown.setAttribute('data-hs-select-dropdown', '');
        if (this.dropdownScope === 'parent')
            this.dropdown.classList.add('absolute', 'top-full');
        this.dropdown.role = 'listbox';
        this.dropdown.tabIndex = -1;
        this.dropdown.ariaOrientation = 'vertical';
        if (!this.isOpened)
            this.dropdown.classList.add('hidden');
        if (this.dropdownClasses)
            (0, utils_1.classToClassList)(this.dropdownClasses, this.dropdown);
        if (this.wrapper)
            this.wrapper.append(this.dropdown);
        if (this.dropdown && this.hasSearch)
            this.buildSearch();
        if (this.selectOptions)
            this.selectOptions.forEach(function (props, i) {
                return _this.buildOption(props.title, props.val, props.disabled, props.selected, props.options, "".concat(i));
            });
        if (this.apiUrl)
            this.optionsFromRemoteData();
        if (this.dropdownScope === 'window')
            this.buildPopper();
    };
    HSSelect.prototype.buildPopper = function () {
        if (typeof Popper !== 'undefined' && Popper.createPopper) {
            document.body.appendChild(this.dropdown);
            this.popperInstance = Popper.createPopper(this.mode === 'tags' ? this.wrapper : this.toggle, this.dropdown, {
                placement: constants_1.POSITIONS[this.dropdownPlacement] || 'bottom',
                strategy: 'fixed',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 5],
                        },
                    },
                ],
            });
        }
    };
    HSSelect.prototype.updateDropdownWidth = function () {
        var toggle = this.mode === 'tags' ? this.wrapper : this.toggle;
        this.dropdown.style.width = "".concat(toggle.clientWidth, "px");
    };
    HSSelect.prototype.buildSearch = function () {
        var _this = this;
        var input;
        this.searchWrapper = (0, utils_1.htmlToElement)(this.searchWrapperTemplate || '<div></div>');
        if (this.searchWrapperClasses)
            (0, utils_1.classToClassList)(this.searchWrapperClasses, this.searchWrapper);
        input = this.searchWrapper.querySelector('[data-input]');
        var search = (0, utils_1.htmlToElement)(this.searchTemplate || '<input type="text" />');
        this.search = (search.tagName === 'INPUT' ? search : search.querySelector(':scope input'));
        this.search.placeholder = this.searchPlaceholder;
        if (this.searchClasses)
            (0, utils_1.classToClassList)(this.searchClasses, this.search);
        if (this.searchId)
            this.search.id = this.searchId;
        this.search.addEventListener('input', (0, utils_1.debounce)(function (evt) {
            if (_this.apiUrl)
                _this.remoteSearch(evt.target.value);
            else
                _this.searchOptions(evt.target.value);
        }));
        if (input)
            input.append(search);
        else
            this.searchWrapper.append(search);
        this.dropdown.append(this.searchWrapper);
    };
    HSSelect.prototype.buildOption = function (title, val, disabled, selected, options, index, id) {
        var _this = this;
        var _a;
        if (disabled === void 0) { disabled = false; }
        if (selected === void 0) { selected = false; }
        if (index === void 0) { index = '1'; }
        var template = null;
        var titleWrapper = null;
        var iconWrapper = null;
        var descriptionWrapper = null;
        var option = (0, utils_1.htmlToElement)(this.optionTag || '<div></div>');
        option.setAttribute('data-value', val);
        option.setAttribute('data-title-value', title);
        option.setAttribute('tabIndex', index);
        option.classList.add('cursor-pointer');
        option.setAttribute('data-id', id || "".concat(this.optionId));
        if (!id)
            this.optionId++;
        if (disabled)
            option.classList.add('disabled');
        if (selected) {
            if (this.isMultiple)
                this.value = __spreadArray(__spreadArray([], this.value, true), [val], false);
            else
                this.value = val;
        }
        if (this.optionTemplate) {
            template = (0, utils_1.htmlToElement)(this.optionTemplate);
            option.append(template);
        }
        if (template) {
            titleWrapper = template.querySelector('[data-title]');
            titleWrapper.textContent = title || '';
        }
        else {
            option.textContent = title || '';
        }
        if (options) {
            if (options.icon) {
                var img = (0, utils_1.htmlToElement)((_a = this.apiIconTag) !== null && _a !== void 0 ? _a : options.icon);
                img.classList.add('max-w-full');
                if (this.apiUrl) {
                    img.setAttribute('alt', title);
                    img.setAttribute('src', options.icon);
                }
                if (template) {
                    iconWrapper = template.querySelector('[data-icon]');
                    iconWrapper.append(img);
                }
                else {
                    var icon = (0, utils_1.htmlToElement)('<div></div>');
                    if (this.iconClasses)
                        (0, utils_1.classToClassList)(this.iconClasses, icon);
                    icon.append(img);
                    option.append(icon);
                }
            }
            if (options.description) {
                if (template) {
                    descriptionWrapper = template.querySelector('[data-description]');
                    if (descriptionWrapper)
                        descriptionWrapper.append(options.description);
                }
                else {
                    var description = (0, utils_1.htmlToElement)('<div></div>');
                    description.textContent = options.description;
                    if (this.descriptionClasses)
                        (0, utils_1.classToClassList)(this.descriptionClasses, description);
                    option.append(description);
                }
            }
        }
        if (template &&
            template.querySelector('[data-icon]') &&
            !options &&
            !(options === null || options === void 0 ? void 0 : options.icon)) {
            template.querySelector('[data-icon]').classList.add('hidden');
        }
        if (this.value &&
            (this.isMultiple ? this.value.includes(val) : this.value === val))
            option.classList.add('selected');
        if (!disabled)
            option.addEventListener('click', function () { return _this.onSelectOption(val); });
        if (this.optionClasses)
            (0, utils_1.classToClassList)(this.optionClasses, option);
        if (this.dropdown)
            this.dropdown.append(option);
        if (selected)
            this.setNewValue();
    };
    HSSelect.prototype.buildOptionFromRemoteData = function (title, val, disabled, selected, index, id, options) {
        if (disabled === void 0) { disabled = false; }
        if (selected === void 0) { selected = false; }
        if (index === void 0) { index = '1'; }
        if (index) {
            this.buildOption(title, val, disabled, selected, options, index, id);
        }
        else {
            alert('ID parameter is required for generating remote options! Please check your API endpoint have it.');
        }
    };
    HSSelect.prototype.buildOptionsFromRemoteData = function (data) {
        var _this = this;
        data.forEach(function (el, i) {
            var id = null;
            var title = '';
            var options = {
                id: '',
                title: '',
                icon: null,
                description: null,
                rest: {},
            };
            Object.keys(el).forEach(function (key) {
                var _a;
                if (el[_this.apiFieldsMap.id])
                    id = el[_this.apiFieldsMap.id];
                if (el[_this.apiFieldsMap.title])
                    title = el[_this.apiFieldsMap.title];
                if (el[_this.apiFieldsMap.icon])
                    options.icon = el[_this.apiFieldsMap.icon];
                if (el[(_a = _this.apiFieldsMap) === null || _a === void 0 ? void 0 : _a.description])
                    options.description = el[_this.apiFieldsMap.description];
                options.rest[key] = el[key];
            });
            _this.buildOriginalOption(title, title, id, false, false, options);
            _this.buildOptionFromRemoteData(title, title, false, false, "".concat(i), id, options);
        });
        this.sortElements(this.el, 'option');
        this.sortElements(this.dropdown, '[data-value]');
    };
    HSSelect.prototype.optionsFromRemoteData = function () {
        return __awaiter(this, arguments, void 0, function (val) {
            var res;
            if (val === void 0) { val = ''; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiRequest(val)];
                    case 1:
                        res = _a.sent();
                        this.remoteOptions = res;
                        if (res.length)
                            this.buildOptionsFromRemoteData(this.remoteOptions);
                        else
                            console.log('There is no data were responded!');
                        return [2 /*return*/];
                }
            });
        });
    };
    HSSelect.prototype.apiRequest = function () {
        return __awaiter(this, arguments, void 0, function (val) {
            var url, search, query, options, req, res, err_1;
            if (val === void 0) { val = ''; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        url = this.apiUrl;
                        search = this.apiSearchQueryKey
                            ? "".concat(this.apiSearchQueryKey, "=").concat(val.toLowerCase())
                            : null;
                        query = "".concat(this.apiQuery);
                        options = this.apiOptions || {};
                        if (search)
                            url += "?".concat(search);
                        if (this.apiQuery)
                            url += "".concat(search ? '&' : '?').concat(query);
                        return [4 /*yield*/, fetch(url, options)];
                    case 1:
                        req = _a.sent();
                        return [4 /*yield*/, req.json()];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, this.apiDataPart ? res[this.apiDataPart] : res];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HSSelect.prototype.sortElements = function (container, selector) {
        var items = Array.from(container.querySelectorAll(selector));
        items.sort(function (a, b) {
            var isASelected = a.classList.contains('selected') || a.hasAttribute('selected');
            var isBSelected = b.classList.contains('selected') || b.hasAttribute('selected');
            if (isASelected && !isBSelected)
                return -1;
            if (!isASelected && isBSelected)
                return 1;
            return 0;
        });
        items.forEach(function (item) { return container.appendChild(item); });
    };
    HSSelect.prototype.remoteSearch = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var res, newIds, restOptions, pseudoOptions, options;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiRequest(val)];
                    case 1:
                        res = _a.sent();
                        this.remoteOptions = res;
                        newIds = res.map(function (item) { return "".concat(item.id); });
                        restOptions = null;
                        pseudoOptions = this.dropdown.querySelectorAll('[data-value]');
                        options = this.el.querySelectorAll('[data-hs-select-option]');
                        options.forEach(function (el) {
                            var _a;
                            var dataId = el.getAttribute('data-id');
                            if (!newIds.includes(dataId) && !((_a = _this.value) === null || _a === void 0 ? void 0 : _a.includes(el.value)))
                                _this.destroyOriginalOption(el.value);
                        });
                        pseudoOptions.forEach(function (el) {
                            var _a;
                            var dataId = el.getAttribute('data-id');
                            if (!newIds.includes(dataId) &&
                                !((_a = _this.value) === null || _a === void 0 ? void 0 : _a.includes(el.getAttribute('data-value'))))
                                _this.destroyOption(el.getAttribute('data-value'));
                            else
                                newIds = newIds.filter(function (item) { return item !== dataId; });
                        });
                        restOptions = res.filter(function (item) {
                            return newIds.includes("".concat(item.id));
                        });
                        if (restOptions.length)
                            this.buildOptionsFromRemoteData(restOptions);
                        else
                            console.log('There is no data were responded!');
                        return [2 /*return*/];
                }
            });
        });
    };
    HSSelect.prototype.destroyOption = function (val) {
        var option = this.dropdown.querySelector("[data-value=\"".concat(val, "\"]"));
        if (!option)
            return false;
        option.remove();
    };
    HSSelect.prototype.buildOriginalOption = function (title, val, id, disabled, selected, options) {
        var option = (0, utils_1.htmlToElement)('<option></option>');
        option.setAttribute('value', val);
        if (disabled)
            option.setAttribute('disabled', 'disabled');
        if (selected)
            option.setAttribute('selected', 'selected');
        if (id)
            option.setAttribute('data-id', id);
        option.setAttribute('data-hs-select-option', JSON.stringify(options));
        option.innerText = title;
        this.el.append(option);
    };
    HSSelect.prototype.destroyOriginalOption = function (val) {
        var option = this.el.querySelector("[value=\"".concat(val, "\"]"));
        if (!option)
            return false;
        option.remove();
    };
    HSSelect.prototype.buildTagsInputHelper = function () {
        this.tagsInputHelper = document.createElement('span');
        this.tagsInputHelper.style.fontSize = window.getComputedStyle(this.tagsInput).fontSize;
        this.tagsInputHelper.style.fontFamily = window.getComputedStyle(this.tagsInput).fontFamily;
        this.tagsInputHelper.style.fontWeight = window.getComputedStyle(this.tagsInput).fontWeight;
        this.tagsInputHelper.style.letterSpacing = window.getComputedStyle(this.tagsInput).letterSpacing;
        this.tagsInputHelper.style.visibility = 'hidden';
        this.tagsInputHelper.style.whiteSpace = 'pre';
        this.tagsInputHelper.style.position = 'absolute';
        this.wrapper.appendChild(this.tagsInputHelper);
    };
    HSSelect.prototype.calculateInputWidth = function () {
        this.tagsInputHelper.textContent =
            this.tagsInput.value ||
                this.tagsInput.placeholder;
        var inputPadding = parseInt(window.getComputedStyle(this.tagsInput).paddingLeft) +
            parseInt(window.getComputedStyle(this.tagsInput).paddingRight);
        var inputBorder = parseInt(window.getComputedStyle(this.tagsInput).borderLeftWidth) +
            parseInt(window.getComputedStyle(this.tagsInput).borderRightWidth);
        var newWidth = this.tagsInputHelper.offsetWidth + inputPadding + inputBorder;
        var maxWidth = this.wrapper.offsetWidth -
            (parseInt(window.getComputedStyle(this.wrapper).paddingLeft) +
                parseInt(window.getComputedStyle(this.wrapper).paddingRight));
        this.tagsInput.style.width = "".concat(Math.min(newWidth, maxWidth) + 2, "px");
    };
    HSSelect.prototype.adjustInputWidth = function () {
        this.buildTagsInputHelper();
        this.calculateInputWidth();
    };
    HSSelect.prototype.onSelectOption = function (val) {
        var _this = this;
        this.clearSelections();
        if (this.isMultiple) {
            this.value = this.value.includes(val)
                ? Array.from(this.value).filter(function (el) { return el !== val; })
                : __spreadArray(__spreadArray([], Array.from(this.value), true), [val], false);
            this.selectMultipleItems();
            this.setNewValue();
        }
        else {
            this.value = val;
            this.selectSingleItem();
            this.setNewValue();
        }
        this.fireEvent('change', this.value);
        (0, utils_1.dispatch)('change.hs.select', this.el, this.value);
        if (this.mode === 'tags') {
            var intersection = this.selectedItems.filter(function (x) { return !_this.value.includes(x); });
            if (intersection.length) {
                intersection.forEach(function (el) {
                    _this.selectedItems = _this.selectedItems.filter(function (elI) { return elI !== el; });
                    _this.wrapper.querySelector("[data-tag-value=\"".concat(el, "\"]")).remove();
                });
            }
            this.resetTagsInputField();
        }
        if (!this.isMultiple) {
            if (this.toggle.querySelector('[data-icon]'))
                this.setToggleIcon();
            if (this.toggle.querySelector('[data-title]'))
                this.setToggleTitle();
            this.close();
        }
        if (!this.value.length && this.mode === 'tags')
            this.reassignTagsInputPlaceholder(this.placeholder);
        if (this.isOpened && this.mode === 'tags' && this.tagsInput)
            this.tagsInput.focus();
        this.triggerChangeEventForNativeSelect();
    };
    HSSelect.prototype.triggerChangeEventForNativeSelect = function () {
        // TODO:: test for bugs after comment the line below
        // (this.el as HTMLSelectElement).value = `${this.value}`;
        var selectChangeEvent = new Event('change', { bubbles: true });
        this.el.dispatchEvent(selectChangeEvent);
    };
    HSSelect.prototype.addSelectOption = function (title, val, disabled, selected, options) {
        this.selectOptions = __spreadArray(__spreadArray([], this.selectOptions, true), [
            {
                title: title,
                val: val,
                disabled: disabled,
                selected: selected,
                options: options,
            },
        ], false);
    };
    HSSelect.prototype.removeSelectOption = function (val, isArray) {
        if (isArray === void 0) { isArray = false; }
        var hasOption = !!this.selectOptions.some(function (el) { return el.val === val; });
        if (!hasOption)
            return false;
        this.selectOptions = this.selectOptions.filter(function (el) { return el.val !== val; });
        this.value = isArray
            ? this.value.filter(function (item) { return item !== val; })
            : val;
    };
    HSSelect.prototype.resetTagsInputField = function () {
        this.tagsInput.value = '';
        this.reassignTagsInputPlaceholder('');
        this.searchOptions('');
    };
    HSSelect.prototype.clearSelections = function () {
        Array.from(this.dropdown.children).forEach(function (el) {
            if (el.classList.contains('selected'))
                el.classList.remove('selected');
        });
        Array.from(this.el.children).forEach(function (el) {
            if (el.selected)
                el.selected = false;
        });
    };
    HSSelect.prototype.setNewValue = function () {
        var _a;
        if (this.mode === 'tags') {
            this.setTagsItems();
        }
        else {
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.length) {
                this.toggleTextWrapper.innerHTML = this.stringFromValue();
            }
            else
                this.toggleTextWrapper.innerHTML = this.placeholder;
        }
    };
    HSSelect.prototype.stringFromValueBasic = function (options) {
        var _this = this;
        var value = [];
        var title = '';
        options.forEach(function (el) {
            if (_this.isMultiple) {
                if (_this.value.includes(el.val))
                    value.push(el.title);
            }
            else {
                if (_this.value === el.val)
                    value.push(el.title);
            }
        });
        if (this.toggleCountText &&
            this.toggleCountText !== '' &&
            value.length >= this.toggleCountTextMinItems) {
            if (this.toggleCountTextMode === 'nItemsAndCount') {
                var nItems = value.slice(0, this.toggleCountTextMinItems - 1);
                title = "".concat(nItems.join(this.toggleSeparators.items), " ").concat(this.toggleSeparators.betweenItemsAndCounter, " ").concat(value.length - nItems.length, " ").concat(this.toggleCountText);
            }
            else {
                title = "".concat(value.length, " ").concat(this.toggleCountText);
            }
        }
        else {
            title = value.join(this.toggleSeparators.items);
        }
        return title;
    };
    HSSelect.prototype.stringFromValueRemoteData = function () {
        var _this = this;
        var options = this.dropdown.querySelectorAll('[data-title-value]');
        var value = [];
        var title = '';
        options.forEach(function (el) {
            var dataValue = el.getAttribute('data-value');
            if (_this.isMultiple) {
                if (_this.value.includes(dataValue))
                    value.push(dataValue);
            }
            else {
                if (_this.value === dataValue)
                    value.push(dataValue);
            }
        });
        if (this.toggleCountText &&
            this.toggleCountText !== '' &&
            value.length >= this.toggleCountTextMinItems) {
            if (this.toggleCountTextMode === 'nItemsAndCount') {
                var nItems = value.slice(0, this.toggleCountTextMinItems - 1);
                title = "".concat(nItems.join(this.toggleSeparators.items), " ").concat(this.toggleSeparators.betweenItemsAndCounter, " ").concat(value.length - nItems.length, " ").concat(this.toggleCountText);
            }
            else {
                title = "".concat(value.length, " ").concat(this.toggleCountText);
            }
        }
        else {
            title = value.join(this.toggleSeparators.items);
        }
        return title;
    };
    HSSelect.prototype.stringFromValue = function () {
        var result = this.apiUrl
            ? this.stringFromValueRemoteData()
            : this.stringFromValueBasic(this.selectOptions);
        return result;
    };
    HSSelect.prototype.selectSingleItem = function () {
        var _this = this;
        var selectedOption = Array.from(this.el.children).find(function (el) { return _this.value === el.value; });
        selectedOption.selected = true;
        var selectedItem = Array.from(this.dropdown.children).find(function (el) {
            return _this.value === el.getAttribute('data-value');
        });
        if (selectedItem)
            selectedItem.classList.add('selected');
    };
    HSSelect.prototype.selectMultipleItems = function () {
        var _this = this;
        Array.from(this.dropdown.children)
            .filter(function (el) { return _this.value.includes(el.getAttribute('data-value')); })
            .forEach(function (el) { return el.classList.add('selected'); });
        Array.from(this.el.children)
            .filter(function (el) { return _this.value.includes(el.value); })
            .forEach(function (el) { return (el.selected = true); });
    };
    HSSelect.prototype.unselectMultipleItems = function () {
        Array.from(this.dropdown.children).forEach(function (el) {
            return el.classList.remove('selected');
        });
        Array.from(this.el.children).forEach(function (el) { return (el.selected = false); });
    };
    HSSelect.prototype.searchOptions = function (val) {
        var _this = this;
        if (this.searchNoResult) {
            this.searchNoResult.remove();
            this.searchNoResult = null;
        }
        this.searchNoResult = (0, utils_1.htmlToElement)(this.searchNoResultTemplate);
        this.searchNoResult.innerText = this.searchNoResultText;
        (0, utils_1.classToClassList)(this.searchNoResultClasses, this.searchNoResult);
        var options = this.dropdown.querySelectorAll('[data-value]');
        var hasItems = false;
        var countLimit;
        if (this.searchLimit)
            countLimit = 0;
        options.forEach(function (el) {
            var optionVal = el.getAttribute('data-title-value').toLocaleLowerCase();
            var regexSafeVal = val
                ? val
                    .split('')
                    .map(function (char) {
                    return char.match(/\w/) ? "".concat(char, "[\\W_]*") : '\\W*';
                })
                    .join('')
                : '';
            var regex = new RegExp(regexSafeVal, 'i');
            var directMatch = _this.isSearchDirectMatch;
            var cleanedOptionVal = optionVal.trim();
            var condition = val
                ? directMatch
                    ? !cleanedOptionVal.toLowerCase().includes(val.toLowerCase()) ||
                        countLimit >= _this.searchLimit
                    : !regex.test(cleanedOptionVal) || countLimit >= _this.searchLimit
                : !regex.test(cleanedOptionVal);
            if (condition) {
                el.classList.add('hidden');
            }
            else {
                el.classList.remove('hidden');
                hasItems = true;
                if (_this.searchLimit)
                    countLimit++;
            }
        });
        if (!hasItems)
            this.dropdown.append(this.searchNoResult);
    };
    HSSelect.prototype.eraseToggleIcon = function () {
        var icon = this.toggle.querySelector('[data-icon]');
        if (icon) {
            icon.innerHTML = null;
            icon.classList.add('hidden');
        }
    };
    HSSelect.prototype.eraseToggleTitle = function () {
        var title = this.toggle.querySelector('[data-title]');
        if (title) {
            title.innerHTML = this.placeholder;
        }
        else {
            this.toggleTextWrapper.innerHTML = this.placeholder;
        }
    };
    HSSelect.prototype.toggleFn = function () {
        if (this.isOpened)
            this.close();
        else
            this.open();
    };
    // Public methods
    HSSelect.prototype.destroy = function () {
        var parent = this.el.parentElement.parentElement;
        this.el.classList.remove('hidden');
        this.el.style.display = '';
        parent.prepend(this.el);
        parent.querySelector('.hs-select').remove();
        this.wrapper = null;
    };
    HSSelect.prototype.open = function () {
        var _this = this;
        var _a;
        var currentlyOpened = ((_a = window === null || window === void 0 ? void 0 : window.$hsSelectCollection) === null || _a === void 0 ? void 0 : _a.find(function (el) { return el.element.isOpened; })) || null;
        if (currentlyOpened)
            currentlyOpened.element.close();
        if (this.animationInProcess)
            return false;
        this.animationInProcess = true;
        if (this.dropdownScope === 'window')
            this.dropdown.classList.add('invisible');
        this.dropdown.classList.remove('hidden');
        this.recalculateDirection();
        setTimeout(function () {
            var _a;
            if ((_a = _this === null || _this === void 0 ? void 0 : _this.toggle) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
                _this.toggle.ariaExpanded = 'true';
            _this.wrapper.classList.add('active');
            _this.dropdown.classList.add('opened');
            if (_this.dropdown.classList.contains('w-full') &&
                _this.dropdownScope === 'window')
                _this.updateDropdownWidth();
            if (_this.popperInstance && _this.dropdownScope === 'window') {
                _this.popperInstance.update();
                _this.dropdown.classList.remove('invisible');
            }
            if (_this.hasSearch && !_this.preventSearchFocus)
                _this.search.focus();
            _this.animationInProcess = false;
        });
        this.isOpened = true;
    };
    HSSelect.prototype.close = function () {
        var _this = this;
        var _a, _b, _c, _d;
        if (this.animationInProcess)
            return false;
        this.animationInProcess = true;
        if ((_a = this === null || this === void 0 ? void 0 : this.toggle) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
            this.toggle.ariaExpanded = 'false';
        this.wrapper.classList.remove('active');
        this.dropdown.classList.remove('opened', 'bottom-full', 'top-full');
        if ((_b = this.dropdownDirectionClasses) === null || _b === void 0 ? void 0 : _b.bottom)
            this.dropdown.classList.remove(this.dropdownDirectionClasses.bottom);
        if ((_c = this.dropdownDirectionClasses) === null || _c === void 0 ? void 0 : _c.top)
            this.dropdown.classList.remove(this.dropdownDirectionClasses.top);
        this.dropdown.style.marginTop = '';
        this.dropdown.style.marginBottom = '';
        (0, utils_1.afterTransition)(this.dropdown, function () {
            _this.dropdown.classList.add('hidden');
            if (_this.hasSearch) {
                _this.search.value = '';
                _this.search.dispatchEvent(new Event('input', { bubbles: true }));
                _this.search.blur();
            }
            _this.animationInProcess = false;
        });
        (_d = this.dropdown
            .querySelector('.hs-select-option-highlighted')) === null || _d === void 0 ? void 0 : _d.classList.remove('hs-select-option-highlighted');
        this.isOpened = false;
    };
    HSSelect.prototype.addOption = function (items) {
        var _this = this;
        var i = "".concat(this.selectOptions.length);
        var addOption = function (option) {
            var title = option.title, val = option.val, disabled = option.disabled, selected = option.selected, options = option.options;
            var hasOption = !!_this.selectOptions.some(function (el) { return el.val === val; });
            if (!hasOption) {
                _this.addSelectOption(title, val, disabled, selected, options);
                _this.buildOption(title, val, disabled, selected, options, i);
                _this.buildOriginalOption(title, val, null, disabled, selected, options);
                if (selected && !_this.isMultiple)
                    _this.onSelectOption(val);
            }
        };
        if (Array.isArray(items)) {
            items.forEach(function (option) {
                addOption(option);
            });
        }
        else {
            addOption(items);
        }
    };
    HSSelect.prototype.removeOption = function (values) {
        var _this = this;
        var removeOption = function (val, isArray) {
            if (isArray === void 0) { isArray = false; }
            var hasOption = !!_this.selectOptions.some(function (el) { return el.val === val; });
            if (hasOption) {
                _this.removeSelectOption(val, isArray);
                _this.destroyOption(val);
                _this.destroyOriginalOption(val);
                if (_this.value === val) {
                    _this.value = null;
                    _this.eraseToggleTitle();
                    _this.eraseToggleIcon();
                }
            }
        };
        if (Array.isArray(values)) {
            values.forEach(function (val) {
                removeOption(val, _this.isMultiple);
            });
        }
        else {
            removeOption(values, this.isMultiple);
        }
        this.setNewValue();
    };
    HSSelect.prototype.recalculateDirection = function () {
        var _a, _b, _c, _d;
        if ((0, utils_1.isEnoughSpace)(this.dropdown, this.toggle || this.tagsInput, 'bottom', this.dropdownSpace, this.viewport)) {
            this.dropdown.classList.remove('bottom-full');
            if ((_a = this.dropdownDirectionClasses) === null || _a === void 0 ? void 0 : _a.bottom)
                this.dropdown.classList.remove(this.dropdownDirectionClasses.bottom);
            this.dropdown.style.marginBottom = '';
            this.dropdown.classList.add('top-full');
            if ((_b = this.dropdownDirectionClasses) === null || _b === void 0 ? void 0 : _b.top)
                this.dropdown.classList.add(this.dropdownDirectionClasses.top);
            this.dropdown.style.marginTop = "".concat(this.dropdownSpace, "px");
        }
        else {
            this.dropdown.classList.remove('top-full');
            if ((_c = this.dropdownDirectionClasses) === null || _c === void 0 ? void 0 : _c.top)
                this.dropdown.classList.remove(this.dropdownDirectionClasses.top);
            this.dropdown.style.marginTop = '';
            this.dropdown.classList.add('bottom-full');
            if ((_d = this.dropdownDirectionClasses) === null || _d === void 0 ? void 0 : _d.bottom)
                this.dropdown.classList.add(this.dropdownDirectionClasses.bottom);
            this.dropdown.style.marginBottom = "".concat(this.dropdownSpace, "px");
        }
    };
    // Static methods
    HSSelect.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsSelectCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSSelect.autoInit = function () {
        if (!window.$hsSelectCollection)
            window.$hsSelectCollection = [];
        document
            .querySelectorAll('[data-hs-select]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsSelectCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; })) {
                var data = el.getAttribute('data-hs-select');
                var options = data ? JSON.parse(data) : {};
                new HSSelect(el, options);
            }
        });
        if (window.$hsSelectCollection) {
            window.addEventListener('click', function (evt) {
                var evtTarget = evt.target;
                HSSelect.closeCurrentlyOpened(evtTarget);
            });
            document.addEventListener('keydown', function (evt) {
                return HSSelect.accessibility(evt);
            });
        }
    };
    HSSelect.open = function (target) {
        var elInCollection = window.$hsSelectCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection && !elInCollection.element.isOpened)
            elInCollection.element.open();
    };
    HSSelect.close = function (target) {
        var elInCollection = window.$hsSelectCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection && elInCollection.element.isOpened) {
            elInCollection.element.close();
        }
    };
    HSSelect.closeCurrentlyOpened = function (evtTarget) {
        if (evtTarget === void 0) { evtTarget = null; }
        if (!evtTarget.closest('.hs-select.active') &&
            !evtTarget.closest('[data-hs-select-dropdown].opened')) {
            var currentlyOpened = window.$hsSelectCollection.filter(function (el) { return el.element.isOpened; }) || null;
            if (currentlyOpened) {
                currentlyOpened.forEach(function (el) {
                    el.element.close();
                });
            }
        }
    };
    // Accessibility methods
    HSSelect.accessibility = function (evt) {
        var target = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
        if (target &&
            constants_1.SELECT_ACCESSIBILITY_KEY_SET.includes(evt.code) &&
            !evt.metaKey) {
            switch (evt.code) {
                case 'Escape':
                    evt.preventDefault();
                    this.onEscape();
                    break;
                case 'ArrowUp':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onArrow();
                    break;
                case 'ArrowDown':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onArrow(false);
                    break;
                case 'Tab':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onTab(evt.shiftKey);
                    break;
                case 'Home':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onStartEnd();
                    break;
                case 'End':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onStartEnd(false);
                    break;
                case 'Enter':
                    evt.preventDefault();
                    this.onEnter(evt);
                    break;
                default:
                    break;
            }
        }
    };
    HSSelect.onEscape = function () {
        var target = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
        if (target)
            target.element.close();
    };
    HSSelect.onArrow = function (isArrowUp) {
        if (isArrowUp === void 0) { isArrowUp = true; }
        var target = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
        if (target) {
            var dropdown = target.element.dropdown;
            if (!dropdown)
                return false;
            var preparedOptions = isArrowUp
                ? Array.from(dropdown.querySelectorAll(':scope > *:not(.hidden)')).reverse()
                : Array.from(dropdown.querySelectorAll(':scope > *:not(.hidden)'));
            var options = preparedOptions.filter(function (el) { return !el.classList.contains('disabled'); });
            var current_1 = dropdown.querySelector('.hs-select-option-highlighted') ||
                dropdown.querySelector('.selected');
            if (!current_1)
                options[0].classList.add('hs-select-option-highlighted');
            var currentInd = options.findIndex(function (el) { return el === current_1; });
            if (currentInd + 1 < options.length) {
                currentInd++;
            }
            options[currentInd].focus();
            if (current_1)
                current_1.classList.remove('hs-select-option-highlighted');
            options[currentInd].classList.add('hs-select-option-highlighted');
        }
    };
    HSSelect.onTab = function (isArrowUp) {
        if (isArrowUp === void 0) { isArrowUp = true; }
        var target = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
        if (target) {
            var dropdown = target.element.dropdown;
            if (!dropdown)
                return false;
            var preparedOptions = isArrowUp
                ? Array.from(dropdown.querySelectorAll(':scope >  *:not(.hidden)')).reverse()
                : Array.from(dropdown.querySelectorAll(':scope >  *:not(.hidden)'));
            var options = preparedOptions.filter(function (el) { return !el.classList.contains('disabled'); });
            var current_2 = dropdown.querySelector('.hs-select-option-highlighted') ||
                dropdown.querySelector('.selected');
            if (!current_2)
                options[0].classList.add('hs-select-option-highlighted');
            var currentInd = options.findIndex(function (el) { return el === current_2; });
            if (currentInd + 1 < options.length) {
                currentInd++;
            }
            else {
                if (current_2)
                    current_2.classList.remove('hs-select-option-highlighted');
                target.element.close();
                target.element.toggle.focus();
                return false;
            }
            options[currentInd].focus();
            if (current_2)
                current_2.classList.remove('hs-select-option-highlighted');
            options[currentInd].classList.add('hs-select-option-highlighted');
        }
    };
    HSSelect.onStartEnd = function (isStart) {
        if (isStart === void 0) { isStart = true; }
        var target = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
        if (target) {
            var dropdown = target.element.dropdown;
            if (!dropdown)
                return false;
            var preparedOptions = isStart
                ? Array.from(dropdown.querySelectorAll(':scope >  *:not(.hidden)'))
                : Array.from(dropdown.querySelectorAll(':scope >  *:not(.hidden)')).reverse();
            var options = preparedOptions.filter(function (el) { return !el.classList.contains('disabled'); });
            var current = dropdown.querySelector('.hs-select-option-highlighted');
            if (options.length) {
                options[0].focus();
                if (current)
                    current.classList.remove('hs-select-option-highlighted');
                options[0].classList.add('hs-select-option-highlighted');
            }
        }
    };
    HSSelect.onEnter = function (evt) {
        var select = evt.target.previousSibling;
        if (window.$hsSelectCollection.find(function (el) { return el.element.el === select; })) {
            var opened = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
            var target = window.$hsSelectCollection.find(function (el) { return el.element.el === select; });
            opened.element.close();
            target.element.open();
        }
        else {
            var target = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
            if (target)
                target.element.onSelectOption(evt.target.dataset.value || '');
        }
    };
    return HSSelect;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSSelect.autoInit();
    // Uncomment for debug
    // console.log('Select collection:', window.$hsSelectCollection);
});
document.addEventListener('scroll', function () {
    if (!window.$hsSelectCollection)
        return false;
    var target = window.$hsSelectCollection.find(function (el) { return el.element.isOpened; });
    if (target)
        target.element.recalculateDirection();
});
if (typeof window !== 'undefined') {
    window.HSSelect = HSSelect;
}
exports.default = HSSelect;
